<template>
  <div v-if="Propositions?.length > 0">
    <!-- loading -->
    <v-row  v-if="dialog == true">
      <v-col md="12" lg="12" xl="12" cols="12">
        <loadingComponent
          @closeDialog="dialog = $event"
          :messageDialogeProps="messageDialogeError"
          :dialogProps="dialog"
          :loadingProps="loading"
          :errorProps="error"
        />
      </v-col>
    </v-row>
   

    <!-- presentation pdf -->
    <presentationSansAssocie v-if="role ==='Vendeur'"
        :infosCompteurPresentationProps="infosCompteurProps"
        :donnerCompteur="donnerCompteur"
        :parametreCompteur="parametreCompteur"
        :donnerDesFournisseur="filteredPropositions"
        :dataEnedis="enedisData"
        :numCompteur="numCompteur"
        :turpeData="turpeData"
        :indexes="selectedData"
        :typeCompteur="typeCompteur"
        :fournisseurActuelle="fournisseurActuelle"
        :societe="SocieteData"
        :id_historique_cotation="id_historique_cotation"
      />
      <presentation
      v-else
      :infosCompteurPresentationProps="infosCompteurProps"
      :donnerCompteur="donnerCompteur"
      :parametreCompteur="parametreCompteur"
      :donnerDesFournisseur="filteredPropositions"
      :dataEnedis="enedisData"
      :numCompteur="numCompteur"
      :turpeData="turpeData"
      :indexes="selectedData"
      :typeCompteur="typeCompteur"
      :fournisseurActuelle="fournisseurActuelle"
      :societe="SocieteData"
      :id_historique_cotation="id_historique_cotation"
      :date_debut="date_debut"
    />
    <!-- liste proposition par compteur -->

    <FilterPropositions    :offers="Propositions" 
    @filter-applied="handleFilters"/>
    <v-expansion-panels multiple v-model="expandedPanels" class="mb-8 mt-5">
      <v-expansion-panel
        class="px-6 py-4 mt-1"
        style="
          border: 1px solid rgb(199, 204, 216);
          box-shadow: 0px 4px 16px 0px rgb(199, 204, 216);
        "
        v-for="(PDL, indexPDL) in filteredPropositions"
        :key="indexPDL"
      >
      
        <!-- header -->
        <v-expansion-panel-header style="padding: 0px;">
          <div class="d-flex flex-row align-items-center">
            <h6 class="mb-0">Numéro de Compteur :&nbsp;&nbsp;</h6>
            <span
              class="MontSerrat-Bold"
              style="padding-top: 2px; font-size: 15px; font-weight: bold; color: #02325c"
              >{{ PDL.NumCompteur }}</span
            >
            
            <span style="margin-left: auto; margin-right: 50px; font-size: 16px; color: orange" v-if="(PDL.resultat.donnerCompteur['optionTarifaire'] == 'BTINFCU4' || 
              PDL.resultat.donnerCompteur['optionTarifaire'] == 'BTINFMU4') && PDL.resultat.typeCompteur != 'C5C4'">
              Alerte : Le TURPE est calculé sur une estimation de votre consommation répartie sur 4 cadrans.
            </span>
          </div>
        </v-expansion-panel-header>

        <div v-if="filteredData(PDL.resultat?.result).length>0">
          <v-divider class="mt-0"></v-divider>
          <!-- logo list -->
          <ul class="list-inline" style="padding: 0px">
            <li
              class="list-inline-item"
              v-for="(icon, index_v) in filteredData(PDL.resultat?.result)" 
              :key="icon.name"
            >
              <v-tooltip bottom style="z-index:1000;">
                <template v-slot:activator="{ on, attrs }">
                  <div
                    style="
                      position: relative;
                      border: 2px solid #f04f4f;
                      border-radius: 10px;
                      padding: 10px;
                      background: #fff;
                    "
                    class="td-table shadow"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-img width="120px" height="auto" :src="getImageLogo(icon.logo)">
                    </v-img>
                    <v-icon style="position: absolute; top: 2px; right: 2px" color="#EED202"
                      >mdi-alert</v-icon
                    >
                  </div>
                </template>
                <p style="color: white">{{ icon.message }}</p>
              </v-tooltip>
            </li>
          </ul>
        </div>

        <!-- propositions list -->
        <v-expansion-panel-content>
          <v-expansion-panel
            style="
              z-index: 1;
              border-radius: 5px;
              padding: 24px 15px;
              margin-bottom: 20px;
              border: 1px solid rgb(199, 204, 216);
              box-shadow: 0px 4px 10px 0px rgb(174, 209, 204);
            "
            v-for="(company, index) in PDL.resultat.result"
            :key="company.name"
            v-if="'message' in company == false || 'offreIdResult' in company == true"
          >
      
        
        <template  >
          <v-expansion-panel-header
              hide-actions
              class="d-flex flex-column align-items-start pa-0 elevation-0"
              style="z-index: 1; background: #ffffff"
            >
            <!--valider offre button if fournisseur est premio-->
            <!-- <div v-if="company.fournisseur == 'Premio'" class="d-flex flex-row align-items-center">
              <v-btn
                class="ma-0 pa-0"
                :color="$colors[0]"
                @click="validerOffre(company.offerId, company.transactionId, company.demandeur, company.firstName, company.lastName, company.phone, company.email)"
                style="width: 150px; height: 40px; font-size: 14px; margin-left: 10px"
                >Valider l'offre
              </v-btn>
            </div> -->
             
              

              <!-- warning message -->
              <div class="ml-8 mt-2" v-if="company.fournisseur == 'Gazel Energie'">
                <p style="color: red">
                  Attention, avant l'edition du contrat une verification du BILAN
                  2021/2022 est necessaire
                </p>
              </div>
              <div
                outlined
                class="d-flex flex-row"
                style="justify-content: space-between; background: #ffffff"
              >
                <!-- checkbox + logo icon -->
                <div class="mb-2 mt-2">
                  <v-checkbox
                    v-if="
                      PDL.resultat.actuelle == true &&
                      index == 0 &&
                      company.typeFournisseur == 'Actuelle'
                    "
                    style="position: absolute; top: 0; left: 0; z-index: 3"
                    class="ma-0 pa-0"
                    input-value="true"
                    :disabled="true"
                  >
                  </v-checkbox>
                  <v-checkbox
                    v-else
                    style="position: absolute; top: 0; left: 0; z-index: 3"
                    class="ma-0 pa-0"
                    v-model="selectedData[indexPDL]"
                    @click.capture.stop
                    :value="index"
                    :disabled="isSelectionOffreDisabled(index, indexPDL)"

                  >
                  </v-checkbox>
                  <v-img
                    v-if="company.fournisseur == 'OHM'"
                    style="border-radius: 5px"
                    overflow="hiden"
                    max-height="80px"
                    width="200px"
                    class="ml-16 mr-10"
                    contain
                    :src="getImageLogo(company.logo)"
                  >
                  </v-img>
                  <v-img
                    v-else
                    class="ml-16"
                    overflow="hiden"
                    max-height="80px"
                    width="200px"
                    contain
                    :src="getImageLogo(company.logo)"
                  >
                  </v-img>
                </div>
                <div v-if="company.grilleValidite" style="display: flex;justify-content: center;align-items: center;">
                  <p class="d-flex flex-row text-body-1 ma-0 ml-4">
                        <span class="text-body-1 font-weight-light" style="color: #000;margin-right: 10px;"
                          >Grille Validité: </span
                        >
                        <span class="text-body-1 font-weight-bold" style="color: #000">
                          {{ company.grilleValidite || "" }}
                        </span>
                      </p>
                </div>

                <!-- edit icons -->
                <div
                  v-if="
                    company.typeFournisseur !='AuFrn' &&(company.fournisseur != 'Enovos' &&
                      company.fournisseur != 'Synelva' &&
                      company.fournisseur != 'WEKIWI' && company.fournisseur != 'engie' &&
                      company.fournisseur != 'Engie' && company.fournisseur != 'Gazel Energie') ||
                    (company.fournisseur == 'OHM' && company.type == 'Prix Fixe')
                  "
                  style="height: fit-content"
                  @click="readonlyExpansionPanels = true"
                >
                <div v-if="company.typeYears == 'precie'" style="position: absolute; right: 50px; top: 5px; display: flex; align-items: center; gap: 8px;z-index: 999;" >
                  <p style="margin-bottom: 0px;font-size: 16px;">Multi Years </p>
                  <v-switch
                    v-model="company.showMulti"
                    hide-details
                    dense
                    class="ma-0 pa-0"
                    color="primary"
                    @click.capture.stop 
                  ></v-switch>
                </div>
                  <div
                    v-if="
                      company.fournisseur == 'engie' || company.fournisseur == 'Engie'
                    "
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <engiePro
                      @readonlyExpand="readonlyExpansionPanels = $event"
                      :donner="company"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>
                  <div
                    v-if="company.fournisseur == 'mint-energie'"
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <MintEnergie
                      @readonlyExpand="readonlyExpansionPanels = $event"
                      :donner="company"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :parametreCompteur="PDL.resultat.donnerCompteur['parametreCompteur']"
                      :typeCompteur="PDL.resultat.donnerCompteur['typeCompteur']"
                      :marge="marge"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                      :listCompteur="listCompteur"
                      :donnerCompteurs="filteredCompteurResults"
                    />
                  </div>
                  <div
                    v-if="company.fournisseur == 'Ekwateur'"
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <EkwateurContrat
                      @readonlyExpand="readonlyExpansionPanels = $event"
                      :donner="company"
                      :listCompteur="listCompteur"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                      :marge="marge"
                    />
                  </div>
                  <div
                    v-if="
                      company.fournisseur == 'GEG'"
                    style="position: absolute; top: 0px; right: 0px"
                  >
                  <GegContratC4
                    v-if="['C3','C4','C5C4'].includes(PDL.resultat.donnerCompteur['parametreCompteur'])"
                      :donner="company"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :listCompteur="listCompteur"
                      :donnerCompteurs="filteredCompteurResults"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :parametreCompteur="PDL.resultat.donnerCompteur['parametreCompteur']"
                       :typeCompteur="PDL.resultat.donnerCompteur['typeCompteur']"
                       :marge="marge"
                    />
                    
                    <GegContratC5
                      v-else-if="['C5','C5HP','C5BASE'].includes(PDL.resultat.donnerCompteur['parametreCompteur'])"
                      :donner="company"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :listCompteur="listCompteur"
                      :donnerCompteurs="filteredCompteurResults"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :parametreCompteur="PDL.resultat.donnerCompteur['parametreCompteur']"
                       :typeCompteur="PDL.resultat.donnerCompteur['typeCompteur']"
                       :marge="marge"

                    />
                  </div>
                  <div
                    v-if="
                      company.fournisseur == 'TDE' && company.type != 'HORIZON'
                    "
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <Totale
                      :donner="company"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>

                  <div
                    v-if="
                      (company.fournisseur == 'total energie' ||  company.fournisseur == 'TDE') && company.type == 'Horizon'
                    "
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <TotalHorizon
                      :donner="company"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>
                  <div
                    v-if="
                      (company.fournisseur == 'total energie' || company.fournisseur == 'TDE') && company.type == 'Horizon +'
                    "
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <TotalHorizonPlus
                      :donner="company"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                      :listCompteur="listCompteur"
                      :donnerCompteurs="filteredCompteurResults"
                    />
                  </div>
                  <div
                    v-if="company.fournisseur == 'EDS'"
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <edsContrat
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :donner="company"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>
                  <div 
                  v-if="company.fournisseur == 'JPME' && company.typeFournisseur === 'normal' && PDL.resultat.typeCompteur.includes('C5')" 
                  style="position: absolute; top: 0px; right: 0px;"
                  >
                    <JpmeContrat @readonlyExpand="readonlyExpansionPanels = $event" :donner="company"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']" :numCompteur="PDL.resultat.numCompteur" :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis" />
                  </div>
                  <div 
                    v-if="company.fournisseur == 'JPME' && company.typeFournisseur != 'normal' && PDL.resultat.typeCompteur == 'C4'" 
                    style="position: absolute; top: 0px; right: 0px;"
                    >
                      <JpmeContratC4 @readonlyExpand="readonlyExpansionPanels = $event" :donner="company"
                        :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']" :numCompteur="PDL.resultat.numCompteur" :societe="PDL.resultat.dataSociete"
                        :donnerEnedis="PDL.resultat.dataEnedis" />
                  </div>
                  <div
                    v-if="company.fournisseur == 'Primeo' && company.typeFournisseur == 'normal'"
                    style="position: absolute; top: 0px; right: 0px">
                    <!--<premioContrat  :codePremio="codePremio" :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']" :donner="company" :numCompteur="PDL.resultat.numCompteur" :societe="PDL.resultat.dataSociete" :donnerEnedis="PDL.resultat.dataEnedis" />-->
                    <v-btn @click="validerOffreMultiPrimeo(company.idOffre, company.idTransaction, 
                      company.demandeur, 
                      company.firstName, 
                      company.lastName, 
                      company.phone, 
                      company.email, 
                      company, 
                      PDL.resultat.donnerCompteur['optionTarifaire'],
                      listecodePremio,
                      PDL.resultat.numCompteur,
                      PDL.resultat.dataSociete,
                      PDL.resultat.dataEnedis,
                      PDL.resultat.idHsto,
                      PDL)"
                      color="success"
                      style="position: relative; top: 0; right: 0; margin: 8px;"
                      class="validation-btn d-inline-flex align-center"
                      elevation="2"
                      dense>
                     <v-icon left>mdi-check-circle</v-icon>
                     Valider Offre</v-btn>
                    
                    <primeoMulti
                      @readonlyExpand="readonlyExpansionPanels = $event"
                      :codePremio="listecodePremio"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :donner="company"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>
                  <div
                    v-if="company.fournisseur == 'Hellio'"
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <Hellio
                      :donner="company"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>
                  <div
                    v-if="
                      company.fournisseur.toLowerCase() == 'alterna' &&
                      company.type == 'prix fixe'
                    "
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <vattenfallContrat
                      :donner="company"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>
                  <div
                    v-if="company.fournisseur == 'LLUMC5'"
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <LLUMContratElecC5
                      @readonlyExpand="readonlyExpansionPanels = $event"
                      :donner="company"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>
                  <div
                    v-if="company.fournisseur == 'LLUM'"
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <LLUMContratElec
                      @readonlyExpand="readonlyExpansionPanels = $event"
                      :donner="company"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>
                  <div
                    v-if="
                      company.fournisseur == 'Elecocite' &&
                      company.typeFournisseur == 'normal'
                    "
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <ElecociteContrat
                      @readonlyExpand="readonlyExpansionPanels = $event"
                      :donner="company"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>
                  <div
                    v-if="company.fournisseur == 'EngieEc'"
                    style="position: absolute; top: 0px; right: 0px"
                  >
                    <engieECcontrat
                      @readonlyExpand="readonlyExpansionPanels = $event"
                      :donner="company"
                      :optionTarifaire="PDL.resultat.donnerCompteur['optionTarifaire']"
                      :numCompteur="PDL.resultat.numCompteur"
                      :societe="PDL.resultat.dataSociete"
                      :donnerEnedis="PDL.resultat.dataEnedis"
                    />
                  </div>
                </div>
              </div>

              <!-- header informations -->
              <div class="d-flex flex-column ma-4"> 
                <div
                  class="d-flex flex-row flex-wrap align-center"
                  v-if="
                    company.typeFournisseur != 'AuFrn' &&
                    company.typeFournisseur != 'Actuelle'
                  "
                >
                  <p v-if="company.type" class="grey--text font-weight-light mx-2 mb-0">
                    Type d'offre :
                    <span style="color: #1A1A1A" class="text-body-1 font-weight-bold">{{
                      company.type
                    }}</span>
                  </p>
                  <p class="grey--text font-weight-light mx-2 mb-0">
                    Début de contrat :
                    <span style="color: #1A1A1A" class="text-body-1 font-weight-bold">{{
                      company.dateDebut
                    }}</span>
                  </p>
                  <p class="grey--text font-weight-light mx-2 mb-0">
                    Fin de contrat :<span
                      style="color: #1A1A1A"
                      class="text-body-1 font-weight-bold ml-2"
                      >{{ company.dateFin }}</span
                    >
                  </p>
                  <p class="grey--text font-weight-light mb-0 mx-2">
                    Durée de contrat :
                    <span style="color: #1A1A1A" class="text-body-1 font-weight-bold"
                      >{{ !!company.DUREE ? company.DUREE : company.nbrMonth }} mois</span
                    >
                  </p>
                  <p class="grey--text font-weight-light mx-2 mb-0">
                    Budget annuel :<span
                      style="color: #1A1A1A"
                      class="text-body-1 font-weight-bold ml-2"
                      >{{ "" + company.budget?.toLocaleString() }} €</span
                    >
                  </p>
                  <p v-if="showEconomie(PDL.resultat.result,company)" class="grey--text font-weight-light mx-2 mb-0">
                    <span>Economie : </span>
                    <span 
                      :class="getPercentageColorClass(PDL.resultat.result, company)"
                      class="text-body-1 font-weight-bold ml-2">
                      {{ formatPercentage(calulatePercentage(PDL.resultat.result, company)) }} en %/an
                    </span>
                  </p>
                  <p v-if="company.typeFournisseur != 'Actuelle' && company.ajouterMarge" class="grey--text font-weight-light mx-2 mb-0">
                    Type de Remuneration : <span style="color: #1A1A1A" class="text-body-1 font-weight-bold ml-2">{{ getTypeRemuneration(company) }}</span>
                  </p>
                </div>
                <div class="d-flex flex-row flex-wrap align-center" v-else>
                  <p class="grey--text font-weight-light mb-0 mx-2">
                    Type d'offre :
                    <span style="color: #1A1A1A" class="text-body-1 font-weight-bold">{{
                      company.type
                    }}</span>
                  </p>
                  <p class="grey--text font-weight-light mb-0 mx-2">
                    Durée de contrat :
                    <span style="color: #1A1A1A" class="text-body-1 font-weight-bold"
                      >{{ company.DUREE }} mois</span
                    >
                  </p>
                  <p class="grey--text font-weight-light mx-2 mb-0">
                    Budget annuel :<span
                      style="color: #1A1A1A"
                      class="text-body-1 font-weight-bold ml-2"
                      >{{ "" + company.budget?.toLocaleString() }} €</span
                    >
                  </p>
                  <p v-if="company.dateSaisie" class="grey--text font-weight-light mb-0 mx-2"
                      >
                      Date de saisie de l'offre :
                        <span
                          style="color: #1a1a1a"
                          class="text-body-1 font-weight-bold ml-2"
                          >{{company.dateSaisie }}</span
                        >
                      </p>
                  <p v-if="showEconomie(PDL.resultat.result, company)" class="grey--text font-weight-light mx-2 mb-0">
                    Economie : 
                    <span 
                      :class="getPercentageColorClass(PDL.resultat.result, company)"
                      class="text-body-1 font-weight-bold ml-2">
                      {{ formatPercentage(calulatePercentage(PDL.resultat.result, company)) }} en %/an
                    </span>
                  </p>
                  <p v-if="company.typeFournisseur != 'Actuelle' && company.ajouterMarge" class="grey--text font-weight-light mx-2 mb-0">
                    Type de Remuneration : <span style="color: #1A1A1A" class="text-body-1 font-weight-bold ml-2">{{ getTypeRemuneration(company) }}</span>
                  </p>
                </div>
              </div>
              <!-- header price panelData informations -->
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                :style="{ background: company.typeFournisseur === 'Actuelle'? '#F49300' : '#024f72' }"
                class="header d-flex flex-column px-2"
                :id="index"
                v-if="index != panelData"
              >
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="d-flex flex-column pt-0 px-0 pb-0"
                >
                  <v-card
                    class="d-flex flex-row justify-space-between rounded-0"
                    style="background: transparent; box-shadow: 0px 0px 0px 0px"
                  >
                    <v-col
                      class="pa-0"
                      cols="10"
                      sm="4"
                      md="3"
                      lg="2"
                      xl="2"
                      align="center"
                      justify="center"
                    >
                      <p class="d-flex flex-column text-body-1 ma-0">
                        <span class="text-body-1 font-weight-light" style="color: #fff"
                          >Budget KWh</span
                        >
                        <span class="text-body-1 font-weight-bold" style="color: #fff">
                          {{ "" + company.budgetKWH?.toLocaleString() }} €
                        </span>
                      </p>
                    </v-col>
                    <v-col
                      class="pa-0"
                      cols="10"
                      sm="4"
                      md="3"
                      lg="2"
                      xl="2"
                      align="center"
                      justify="center"
                    >
                      <p class="d-flex flex-column text-body-1 ma-0">
                        <span class="text-body-1 font-weight-light" style="color: #fff"
                          >CAPA</span
                        >
                        <span class="text-body-1 font-weight-bold" style="color: #fff">
                          {{
                            company.typeCapa === "Inclus" || company.typeCapa === "CAPAINCLUS"
                              ? "Inclus"
                              : company.budgetCapa === 0
                                ? "0 €"
                                : "" + company.budgetCapa?.toLocaleString() + "€"
                          }}
                        </span>
                      </p>
                    </v-col>
                    <v-col
                      class="pa-0"
                      cols="10"
                      sm="4"
                      md="3"
                      lg="2"
                      xl="2"
                      align="center"
                      justify="center"
                    >
                      <p class="d-flex flex-column text-body-1 ma-0">
                        <span class="text-body-1 font-weight-light" style="color: #fff"
                          >TURPE</span
                        >
                        <span
                          v-if="company.TURPE == 'inclus'"
                          class="text-body-1 font-weight-bold"
                          style="color: #fff"
                          >Inclus</span
                        >
                        <span
                          v-else
                          class="text-body-1 font-weight-bold"
                          style="color: #fff"
                        >
                          {{ "" + company.TURPE?.toLocaleString() }} €
                        </span>
                      </p>
                    </v-col>
                    <v-col
                      class="pa-0"
                      cols="10"
                      sm="4"
                      md="3"
                      lg="2"
                      xl="2"
                      align="center"
                      justify="center"
                    >
                      <p class="d-flex flex-column text-body-1 ma-0">
                        <span class="text-body-1 font-weight-light" style="color: #fff"
                          >TAXE</span
                        >
                        <span class="text-body-1 font-weight-bold" style="color: #fff">
                          {{ "" + company.budgetTaxe?.toLocaleString() }} €
                        </span>
                      </p>
                    </v-col>
                  </v-card>
                </v-col>
              </v-col>
            </v-expansion-panel-header>

            <!-- price info -->
            <v-expansion-panel-content
              class="pa-0"
              style="margin-bottom: 10px;"
              v-if="!company.hasOwnProperty('message')"
            >
              <v-row justify="space-between" outlined no-gutters class="pa-4 header">
                <!-- Prix du KWh -->

                <v-col align="center" cols="10" sm="4" md="3" lg="2" xl="2" class="pl-4">
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C3'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >POINTE</span
                    >
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold">
                      {{ "" + company.unitairepointe?.toLocaleString() }} €/MWh
                    </span>
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5HP'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HP</span
                    >
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold">
                      {{ "" + company.unitairehp?.toLocaleString() }} €/MWh
                    </span>
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5HP'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HC</span
                    >
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold">
                      {{ "" + company.unitairehc?.toLocaleString() }} €/MWh
                    </span>
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5BASE'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >BASE
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company.unitaire?.toLocaleString() }} €/MWh</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HPH
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company.unitairehph?.toLocaleString() }} €/MWh</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HCH
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company.unitairehch?.toLocaleString() }} €/MWh</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HPE
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company.unitairehpe?.toLocaleString() }} €/MWh</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HCE
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company.unitairehce?.toLocaleString() }} €/MWh</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >CEE
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company.cee == 'NON SOUMIS'"
                      >NON SOUMIS</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{ "" + company.cee?.toLocaleString() }}€/MWh</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4" >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >Abonnement mensuel
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company.mensuel?.toLocaleString() }} €</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4" v-if="company?.['abo green']">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >Abonnement Energie Verte
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ (company?.['abo green'] || 0)?.toLocaleString() }} €</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4"  v-if="company?.['abo green budget']">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >Budget Energie Verte
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ (company?.['abo green budget'] || 0)?.toLocaleString() }} €</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4"  v-if="company?.['prixVert']">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >Prix Energie Verte
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ (company?.['prixVert'] || 0)?.toLocaleString() }} €</span
                    >
                  </div>
                  <div 
                  class="d-flex flex-column mb-4"  
                  v-if="company?.typeFournisseur != 'Actuelle' && company?.['commission'] !== null && company?.['commission'] !== undefined">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >Commission
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold">{{ (company?.['commission'] || 0)?.toLocaleString() }} €</span>
                  </div>
                </v-col>

                <!-- CAPA -->
                <v-col
                  align="center"
                  class="pt-0 d-flex flex-column"
                  cols="10"
                  sm="4"
                  md="3"
                  lg="2"
                  xl="2"
                >
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C3'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >POINTE
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company.capa_pointe == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company.typeCapa === "Inclus" || company.typeCapa === "CAPAINCLUS" ? "Inclus"
                        :company.budgetCapa == 0
                          ? "0 €"
                          : "" + company.capa_pointe?.toLocaleString() + "€/MWh"
                      }}
                    </span>
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5HP'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HP</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company.capa_hp == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company.typeCapa === "Inclus" || company.typeCapa === "CAPAINCLUS"
                         ? "Inclus":
                        company.budgetCapa == 0
                          ? "0 €"
                          : "" + company.capa_hp?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5HP'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HC
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company.capa_hc == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company.typeCapa === "Inclus" || company.typeCapa === "CAPAINCLUS"
                        ? "Inclus"
                        : company.budgetCapa == 0
                          ? "0 €"
                          : "" + company.capa_hc?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5BASE'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >BASE
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company.capa_base == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company.typeCapa === "Inclus" || company.typeCapa === "CAPAINCLUS"
                        ? "Inclus"
                        : company.budgetCapa == 0
                          ? "0 €"
                          : "" + company.capa_base?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HPH
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company.capa_hph == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company.typeCapa === "Inclus" || company.typeCapa === "CAPAINCLUS"
                        ? "Inclus"
                        : company.budgetCapa == 0
                          ? "0 €"
                          : "" + company.capa_hph?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HCH
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company.capa_hch == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company.typeCapa === "Inclus" || company.typeCapa === "CAPAINCLUS"
                        ? "Inclus"
                        : company.budgetCapa == 0
                          ? "0 €"
                          : "" + company.capa_hch?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HPE
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company.capa_hpe == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company.typeCapa === "Inclus" || company.typeCapa === "CAPAINCLUS"
                        ? "Inclus"
                        : company.budgetCapa == 0
                          ? "0 €"
                          : "" + company.capa_hpe?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HCE
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company.capa_hce == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company.typeCapa === "Inclus" || company.typeCapa === "CAPAINCLUS"
                        ? "Inclus"
                        : company.budgetCapa == 0
                          ? "0 €"
                          : "" + company.capa_hce?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                </v-col>

                <!-- TURP -->
                <v-col
                  cols="10"
                  sm="4"
                  md="3"
                  lg="2"
                  xl="2"
                  align="center"
                  class="pt-0 d-flex flex-column"
                >
                  <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >Énergie
                      </span>
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-if="company.TURPE == 'inclus'"
                        >Inclus</span
                      >
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-else
                        >{{
                          "" + PDL.resultat.dataTurpe.energieTurp?.toLocaleString()
                        }}
                        €</span
                      >
                    </p>
                  </div>
                  <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >C.A de gestion
                      </span>
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-if="company.CAG == 'inclus'"
                        >Inclus</span
                      >
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-else
                        >{{ "" + company.CAG?.toLocaleString() }} €</span
                      >
                    </p>
                  </div>
                  <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >C.A de comptage
                      </span>
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-if="company.CACC == 'inclus'"
                        >Inclus</span
                      >
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-else
                        >{{ "" + company.CACC?.toLocaleString() }} €</span
                      >
                    </p>
                  </div>
                  <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >CA soutirage
                      </span>
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-if="company.TURPE == 'inclus'"
                        >Inclus</span
                      >
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-else
                        >{{
                          "" + PDL.resultat.dataTurpe.PSTurpe?.toLocaleString()
                        }}
                        €</span
                      >
                    </p>
                  </div>
                </v-col>

                <!-- TAXE -->
                <v-col
                  cols="10"
                  sm="4"
                  md="3"
                  lg="2"
                  xl="2"
                  align="center"
                  class="pt-0 d-flex flex-column"
                >
                  <!-- <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >TCFE
                      </span>
                      <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                        >{{ "" + company.TAXE?.toLocaleString() }} €</span
                      >
                    </p>
                  </div> -->
                  <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >CTA
                      </span>
                      <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                        >{{ "" + company.CTA?.toLocaleString() }} €/an</span
                      >
                    </p>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >CSPE
                      </span>
                      <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                        >{{ (company?.['CSPE'] || 0)?.toLocaleString()  }} €/MWh</span
                      >
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content></template> 
            <template v-if="company.typeYears === 'precie' && company.showMulti == true">
          <div v-for="year in Object.keys(company).filter(key => /^\d{4}$/.test(key))" :key="year" 
      class="mb-6 mt-6 rounded-lg"
      style="border: 1px solid rgb(199, 204, 216); box-shadow: 0px 4px 10px 0px rgb(174, 209, 204);"
    >
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-4" style="display: flex;flex-direction: column;">
            <!-- Year badge -->
            <div class="position-relative mb-2">
              <v-chip color="primary" style="font-size: 22px;" medium >{{ year }}</v-chip>
            </div>

            <!-- header informations for this year -->
            <div class="d-flex flex-column ma-4"> 
                <div
                  class="d-flex flex-row align-center"
                  v-if="
                    company[year]?.typeFournisseur != 'AuFrn' &&
                    company[year]?.typeFournisseur != 'Actuelle'
                  "
                >
                  <p v-if="company[year]?.type" class="grey--text font-weight-light mx-2 mb-0">
                    Type d'offre :
                    <span style="color: #1A1A1A" class="text-body-1 font-weight-bold">{{
                      company[year]?.type
                    }}</span>
                  </p>
                  <p class="grey--text font-weight-light mx-2 mb-0">
                    Début de contrat :
                    <span style="color: #1A1A1A" class="text-body-1 font-weight-bold">{{
                      company[year]?.dateDebut
                    }}</span>
                  </p>
                  <p class="grey--text font-weight-light mx-2 mb-0">
                    Fin de contrat :<span
                      style="color: #1A1A1A"
                      class="text-body-1 font-weight-bold ml-2"
                      >{{ company[year]?.dateFin }}</span
                    >
                  </p>
                  <p class="grey--text font-weight-light mb-0 mx-2">
                    Durée de contrat :
                    <span style="color: #1A1A1A" class="text-body-1 font-weight-bold"
                      >{{ company[year]?.nbrMonth }} mois</span
                    >
                  </p>
                  <p class="grey--text font-weight-light mx-2 mb-0">
                    Budget annuel :<span
                      style="color: #1A1A1A"
                      class="text-body-1 font-weight-bold ml-2"
                      >{{ "" + company[year]?.budget?.toLocaleString() }} €</span
                    >
                  </p>
                </div>
                <div class="d-flex flex-row flex-wrap align-center" v-else>
                  <p class="grey--text font-weight-light mb-0 mx-2">
                    Type d'offre :
                    <span style="color: #1A1A1A" class="text-body-1 font-weight-bold">{{
                      company[year]?.type
                    }}</span>
                  </p>
                  <p class="grey--text font-weight-light mb-0 mx-2">
                    Durée de contrat :
                    <span style="color: #1A1A1A" class="text-body-1 font-weight-bold"
                      >{{ company[year]?.DUREE }} mois</span
                    >
                  </p>
                  <p class="grey--text font-weight-light mx-2 mb-0">
                    Budget annuel :<span
                      style="color: #1A1A1A"
                      class="text-body-1 font-weight-bold ml-2"
                      >{{ "" + company[year]?.budget?.toLocaleString() }} €</span
                    >
                  </p>
                  <p v-if="company[year]?.dateSaisie" class="grey--text font-weight-light mb-0 mx-2"
                      >
                      Date de saisie de l'offre :
                        <span
                          style="color: #1a1a1a"
                          class="text-body-1 font-weight-bold ml-2"
                          >{{company[year]?.dateSaisie }}</span
                        >
                      </p>
                  <p 
                    v-if="showEconomie(PDL.resultat.result,company[year])" 
                    class="grey--text font-weight-light mx-2 mb-0">
                    <span>Economie : </span>
                    <span 
                      :class="getPercentageColorClass(PDL.resultat.result, company[year])"
                      class="text-body-1 font-weight-bold ml-2">
                      {{ formatPercentage(calulatePercentage(PDL.resultat.result, company[year])) }} en %/an
                    </span>
                  </p>
                  <p v-if="company.typeFournisseur != 'Actuelle' && company[year].ajouterMarge" class="grey--text font-weight-light mx-2 mb-0">
                    Type de Remuneration : <span style="color: #1A1A1A" class="text-body-1 font-weight-bold ml-2">{{ getTypeRemuneration(company[year]) }}</span>
                  </p>
                </div>
              </div>

            <!-- Price summary banner -->
            <v-col cols="12" style="background: #024f72" class="header d-flex flex-column px-2">
              <v-card class="d-flex flex-row justify-space-between rounded-0" style="background: transparent; box-shadow: none">
                <v-col class="pa-0" cols="10" sm="4" md="3" lg="2" xl="2" align="center" justify="center">
                  <p class="d-flex flex-column text-body-1 ma-0">
                    <span class="text-body-1 font-weight-light" style="color: #fff">Budget KWh</span>
                    <span class="text-body-1 font-weight-bold" style="color: #fff">
                      {{ company[year]?.budgetKWH?.toLocaleString() }} €
                    </span>
                  </p>
                </v-col>
                <v-col class="pa-0" cols="10" sm="4" md="3" lg="2" xl="2" align="center" justify="center">
                  <p class="d-flex flex-column text-body-1 ma-0">
                    <span class="text-body-1 font-weight-light" style="color: #fff">CAPA</span>
                    <span class="text-body-1 font-weight-bold" style="color: #fff">
                      {{
                        company[year].typeCapa === "Inclus" || company[year].typeCapa === "CAPAINCLUS"
                              ? "Inclus"
                              : company[year].budgetCapa === 0
                              ? "0 €"
                          : "" + company[year]?.budgetCapa?.toLocaleString() + "€/MWh"
                      }}                    </span>
                  </p>
                </v-col>
                <v-col class="pa-0" cols="10" sm="4" md="3" lg="2" xl="2" align="center" justify="center">
                  <p class="d-flex flex-column text-body-1 ma-0">
                    <span class="text-body-1 font-weight-light" style="color: #fff">TURPE</span>
                    <span class="text-body-1 font-weight-bold" style="color: #fff">
                      {{ company[year].dataTurpe.typeTurpe == 'oui' ? "Inclus" : (company[year]?.TURPE?.toLocaleString() + " €") }}
                    </span>
                  </p>
                </v-col>
                <v-col class="pa-0" cols="10" sm="4" md="3" lg="2" xl="2" align="center" justify="center">
                  <p class="d-flex flex-column text-body-1 ma-0">
                    <span class="text-body-1 font-weight-light" style="color: #fff">TAXE</span>
                    <span class="text-body-1 font-weight-bold" style="color: #fff">
                      {{ company[year]?.budgetTaxe?.toLocaleString() }} €
                    </span>
                  </p>
                </v-col>
              </v-card>
            </v-col>
          </v-expansion-panel-header>

          <!-- Expanded price details -->
          <v-expansion-panel-content
              class="pa-0"
              v-if="!company[year]?.hasOwnProperty('message')"
            >
              <v-row justify="space-between" outlined no-gutters class="pa-4 header">
                <!-- Prix du KWh -->

                <v-col align="center" cols="10" sm="4" md="3" lg="2" xl="2" class="pl-4">
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C3'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >POINTE</span
                    >
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold">
                      {{ "" + company[year]?.unitairepointe?.toLocaleString() }} €/MWh
                    </span>
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5HP'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HP</span
                    >
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold">
                      {{ "" + company[year]?.unitairehp?.toLocaleString() }} €/MWh
                    </span>
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5HP'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HC</span
                    >
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold">
                      {{ "" + company[year]?.unitairehc?.toLocaleString() }} €/MWh
                    </span>
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5BASE'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >BASE
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company[year]?.unitaire?.toLocaleString() }} €/MWh</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HPH
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company[year]?.unitairehph?.toLocaleString() }} €/MWh</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HCH
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company[year]?.unitairehch?.toLocaleString() }} €/MWh</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HPE
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company[year]?.unitairehpe?.toLocaleString() }} €/MWh</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HCE
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company[year]?.unitairehce?.toLocaleString() }} €/MWh</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >CEE
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company[year]?.cee == 'NON SOUMIS'"
                      >NON SOUMIS</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{ "" + company[year]?.cee?.toLocaleString() }}€/MWh</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4" v-if="company[year]?.mensuel">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >Abonnement mensuel
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ "" + company[year]?.mensuel?.toLocaleString() }} €</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4" v-if="company[year]?.['abo green']">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >Abonnement Energie Verte
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ (company[year]?.['abo green'] || 0)?.toLocaleString() }} €</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4" v-if="company[year]?.['abo green budget']">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >Budget Energie Verte
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ (company[year]?.['abo green budget'] || 0)?.toLocaleString() }} €</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4" v-if="company[year]?.['prixVert']">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >Prix Energie Verte
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ (company[year]?.['prixVert'] || 0)?.toLocaleString() }} €</span
                    >
                  </div>
                  <div class="d-flex flex-column mb-4" v-if="company[year]?.['commission']">
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >Commission
                    </span>
                    <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                      >{{ (company[year]?.['commission'] || 0)?.toLocaleString() }} €</span
                    >
                  </div>
                </v-col>

                <!-- CAPA -->
                <v-col
                  align="center"
                  class="pt-0 d-flex flex-column"
                  cols="10"
                  sm="4"
                  md="3"
                  lg="2"
                  xl="2"
                >
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C3'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >POINTE
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company[year]?.capa_pointe == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company[year].typeCapa === "Inclus" || company[year].typeCapa === "CAPAINCLUS"
                              ? "Inclus"
                              : company[year].budgetCapa === 0
                              ? "0 €"
                          : "" + company[year]?.capa_pointe?.toLocaleString() + "€/MWh"
                      }}
                    </span>
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5HP'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HP</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company[year]?.capa_hp == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company[year].typeCapa === "Inclus" || company[year].typeCapa === "CAPAINCLUS"
                              ? "Inclus"
                              : company[year].budgetCapa === 0
                              ? "0 €"
                          : "" + company[year]?.capa_hp?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5HP'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HC
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company[year]?.capa_hc == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company[year].typeCapa === "Inclus" || company[year].typeCapa === "CAPAINCLUS"
                              ? "Inclus"
                              : company[year].budgetCapa === 0
                              ? "0 €"
                          : "" + company[year]?.capa_hc?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="PDL.resultat.typeCompteur == 'C5BASE'"
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >BASE
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company[year]?.capa_base == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company[year].typeCapa === "Inclus" || company[year].typeCapa === "CAPAINCLUS"
                              ? "Inclus"
                              : company[year].budgetCapa === 0
                              ? "0 €"
                          : "" + company[year]?.capa_base?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HPH
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company[year]?.capa_hph == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company[year].typeCapa === "Inclus" || company[year].typeCapa === "CAPAINCLUS"
                              ? "Inclus"
                              : company[year].budgetCapa === 0
                              ? "0 €"
                          : "" + company[year]?.capa_hph?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HCH
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company[year]?.capa_hch == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company[year].typeCapa === "Inclus" || company[year].typeCapa === "CAPAINCLUS"
                              ? "Inclus"
                              : company[year].budgetCapa === 0
                              ? "0 €"
                          : "" + company[year]?.capa_hch?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HPE
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company[year]?.capa_hpe == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company[year].typeCapa === "Inclus" || company[year].typeCapa === "CAPAINCLUS"
                              ? "Inclus"
                              : company[year].budgetCapa === 0
                              ? "0 €"
                          : "" + company[year]?.capa_hpe?.toLocaleString() + "€/MWh"
                      }}</span>
                  </div>
                  <div
                    class="d-flex flex-column mb-4"
                    v-if="
                      PDL.resultat.typeCompteur == 'C3' ||
                      PDL.resultat.typeCompteur == 'C4' ||
                      PDL.resultat.typeCompteur == 'C5C4'
                    "
                  >
                    <span
                      class="text-body-1 font-weight-bold mb-1"
                      style="color: #365360; font-weight: 500"
                      >HCE
                    </span>
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-if="company[year]?.capa_hce == 'inclus'"
                      >Inclus</span
                    >
                    <span
                      style="color: #d27d00"
                      class="text-body-1 font-weight-bold"
                      v-else
                      >{{
                        company[year].typeCapa === "Inclus" || company[year].typeCapa === "CAPAINCLUS"
                              ? "Inclus"
                              : company[year].budgetCapa === 0
                              ? "0 €"
                          : "" + company[year]?.capa_hce?.toLocaleString() + "€/MWh"
                      }}</span
                    >
                  </div>
                </v-col>

                <!-- TURP -->
                <v-col
                  cols="10"
                  sm="4"
                  md="3"
                  lg="2"
                  xl="2"
                  align="center"
                  class="pt-0 d-flex flex-column"
                >
                  <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >Énergie
                      </span>
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-if="company[year].dataTurpe.typeTurpe == 'oui'"
                        >Inclus</span
                      >
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-else
                        >{{
                          "" + PDL.resultat.dataTurpe.energieTurp?.toLocaleString()
                        }}
                        €</span
                      >
                    </p>
                  </div>
                  <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >C.A de gestion
                      </span>
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-if="company[year].CAG == 'inclus' || company[year].dataTurpe.typeTurpe == 'oui'"
                        >Inclus</span
                      >
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-else
                        >{{ "" + PDL.resultat.dataTurpe.CAG?.toLocaleString() }} €</span
                      >
                    </p>
                  </div>
                  <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >C.A de comptage
                      </span>
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-if="company[year]?.CACC == 'inclus' || company[year].dataTurpe.typeTurpe == 'oui'"
                        >Inclus</span
                      >
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-else
                        >{{ "" + PDL.resultat.dataTurpe.CACC?.toLocaleString() }} €</span
                      >
                    </p>
                  </div>
                  <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >CA soutirage
                      </span>
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-if="company[year].dataTurpe.typeTurpe == 'oui'"
                        >Inclus</span
                      >
                      <span
                        style="color: #d27d00"
                        class="text-body-1 font-weight-bold"
                        v-else
                        >{{
                          "" + PDL.resultat.dataTurpe.PSTurpe?.toLocaleString()
                        }}
                        €</span
                      >
                    </p>
                  </div>
                </v-col>

                <!-- TAXE -->
                <v-col
                  cols="10"
                  sm="4"
                  md="3"
                  lg="2"
                  xl="2"
                  align="center"
                  class="pt-0 d-flex flex-column"
                >
                  <!-- <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >TCFE
                      </span>
                      <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                        >{{ "" + company[year]?.TAXE?.toLocaleString() }} €</span
                      >
                    </p>
                  </div> -->
                  <div>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >CTA
                      </span>
                      <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                        >{{ "" + PDL.resultat.dataTurpe.CTA?.toLocaleString() }} €/an</span
                      >
                    </p>
                    <p class="mb-4 d-flex flex-column">
                      <span
                        class="text-body-1 font-weight-bold mb-1"
                        style="color: #365360; font-weight: 500"
                        >CSPE
                      </span>
                      <span style="color: #d27d00" class="text-body-1 font-weight-bold"
                        >{{ (PDL.resultat.dataTurpe.cspe || 0)?.toLocaleString()  }} €/MWh</span
                      >
                    </p>
                  </div>
                </v-col>
              </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div></template>
          </v-expansion-panel>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import ElecociteContrat from "../../../views/edition-contrat/Elecocite.vue";
import LLUMContratElecC5 from "../../../views/edition-contrat/LLUMContratElecC5.vue";
import presentation from "../../../views/presentation/NewElecCalcul/newPresentation.vue";
import premioContrat from "../../../views/edition-contrat/primeoEnergie.vue";
import engiePro from "../../../views/edition-contrat/engiePro.vue";
import engieECcontrat from "../../../views/edition-contrat/engieECcontrat.vue";
import gazelContrat from "../../../views/edition-contrat/gazelContrat.vue";
import Totale from "../../../views/edition-contrat/tataleContrat.vue";
import edsContrat from "../../../views/edition-contrat/EDS.vue";
import TotalHorizon from "../../../views/edition-contrat/totalHorizon.vue";
import TotalHorizonPlus from "../../../views/edition-contrat/TotalHorizonPlus.vue";
import vattenfallContrat from "../../../views/edition-contrat/Vattenfall.vue";
import Hellio from "../../../views/edition-contrat/Hellio.vue";
import EkwateurContrat from "../../../views/edition-contrat/Ekwateur.vue";
import LLUMContratElec from "../../../views/edition-contrat/LLUM_ELEC.vue";
import loadingComponent from "../../ui/loading-component";
import primeoMulti from "../../../views/edition-contrat/primeoMulti.vue";
import ohmAvecArenh from "../../../views/edition-contrat/ohmAvecArenh.vue";
import JpmeContrat from "../../../views/edition-contrat/JpmeContrat.vue";
import JpmeContratC4 from "../../../views/edition-contrat/JpmeContratC4.vue";
import presentationSansAssocie from "../../../views/presentation/NewElecCalcul/newPresentationSansAssocie.vue";
import MintEnergie from "../../../views/edition-contrat/MintEnergie.vue";

import axios from "axios";
import GegContratC4 from "../../../views/edition-contrat/GegContratC4.vue";
import GegContratC5 from "../../../views/edition-contrat/GegContratC5.vue";
import FilterPropositions from "./components/filterPropositionsElec.vue";

export default {
  name: "ListDesPropostions",
  
  props: {
    infosCompteurProps: null,
    donnesDesFournisseurs: [],
    optionTarifaire: "",
    parametreCompteur: null,
    Propositions: [],
    SocieteData: [],
    enedisData: [],
    numCompteur: null,
    turpeData: [],
    taxeData: [],
    typeCompteur: null,
    panel: [],
    fournisseurActuelle: null,
    selected: [],
    listCompteur: [],
    donneDeCotation: [],
    donnerCompteur: [],
    id_historique_cotation: null,
    date_debut:"",
    //date_fin: "",
     //associe_vendeur: false,
     marge: null,
    
  },
  components: {
    premioContrat,
    engiePro,
    gazelContrat,
    Totale,
    edsContrat,
    TotalHorizon,
    TotalHorizonPlus,
    vattenfallContrat,
    EkwateurContrat,
    LLUMContratElec,
    primeoMulti,
    ohmAvecArenh,
    presentation,
    LLUMContratElecC5,
    loadingComponent,
    JpmeContrat,
    JpmeContratC4,
    engieECcontrat,
    ElecociteContrat,
    presentationSansAssocie,
    MintEnergie,
    GegContratC4,
    GegContratC5,
    Hellio,
    FilterPropositions
  },
  data() {
    return {
      selectedData: [],
      actuelleExist:false,
      panelData: this.panel,
      readonlyExpansionPanels: false,
      dialog: false,
      loading: false,
      error: false,
      codePremio: "",
      listecodePremio: [],
      messageDialogeError: "",
      messageDialogeSucces: "",
      role : localStorage.getItem("role"),
      expandedPanels: [],
      activeFilters: null,
      filteredPropositions: [...this.Propositions]
    };
  },
 
  mounted() {
    this.role = localStorage.getItem("typeUser");
    for (let i = 0; i < this.Propositions?.length; i++) {
      this.selectedData.splice(i, 0, []);
      if (this.Propositions[i].resultat.result.length > 0) {
        // verifie si une offre actuelle existe
        for (let j = 0; j < this.Propositions[i].resultat.result.length; j++)
          if (this.Propositions[i].resultat.result[j].typeFournisseur == "Actuelle") {
            this.selectedData[i].push(0);
            this.actuelleExist == true;
          }
      }
    }
  },
  computed: {
    filteredCompteurResults() {
      return this.Propositions.map(offer => {
        const filteredResult = offer.resultat.result.filter(compteur => 
          'message' in compteur == false || 'offreIdResult' in compteur == true
        );
        return {
          NumCompteur: offer.NumCompteur,
          resultat: {
            ...offer.resultat,
            result: filteredResult
          }
        };
      });
    }
  },
  watch: {
    Propositions: {
      immediate: true,
      handler(newValue) {
        this.selectedData = [];
        this.filteredPropositions = [...newValue];
        this.actuelleExist = false;

        for (let i = 0; i < newValue?.length; i++) {
          this.selectedData.splice(i, 0, []);
          if (newValue[i].resultat.result.length > 0) {
            // verifie si une offre actuelle existe
            for (let j = 0; j < newValue[i].resultat.result.length; j++) {
              for (var key in newValue[i].resultat.donnerCompteur) {
                if (newValue[i].resultat.donnerCompteur.hasOwnProperty(key)) {
                  newValue[i].resultat.result[j][key] = isNaN(
                    newValue[i].resultat.donnerCompteur[key]
                  )
                    ? newValue[i].resultat.donnerCompteur[key]
                    : parseFloat(newValue[i].resultat.donnerCompteur[key]).toFixed(
                        2
                      );
                }
              }
              newValue[i].resultat.result[j]["duree"] = newValue[
                i
              ].resultat.result[j]["nbrMonth"];
              newValue[i].resultat.result[j][
                "scoreCreditSafe"
              ] = newValue[i].resultat.dataSociete.scoreCreditSafe;

              if (newValue[i].resultat.result[j].typeFournisseur == "Actuelle") {
                this.selectedData[i].push(0);
                this.actuelleExist = true;
              }
            }
          }
        }
        this.expandedPanels = [0] // Expand only the first panel on list change

      }

    },
  },
  
  methods: {
    showEconomie(compteurOffers, offer) {
      return compteurOffers.some(o => o.typeFournisseur == 'Actuelle') && offer.typeFournisseur != 'Actuelle';
    },
    
    // Helper method for safe float conversion
    safeFloat(val) {
      const f = parseFloat(val);
      return isNaN(f) ? 0 : f;
    },
    
    // Calculate energy budget based on offer and compteur data
    calculateEnergieBudget(offer, compteurData) {
      const d = compteurData?.donnerCompteur || {};
      return (
        this.safeFloat(offer.unitairepointe) * this.safeFloat(d.CAP) +
        this.safeFloat(offer.unitairehph) * this.safeFloat(d.CAHPH) +
        this.safeFloat(offer.unitairehch) * this.safeFloat(d.CAHCH) +
        this.safeFloat(offer.unitairehpe) * this.safeFloat(d.CAHPE) +
        this.safeFloat(offer.unitairehce) * this.safeFloat(d.CAHCE) +
        this.safeFloat(offer.unitairehp) * this.safeFloat(d.CAHP) +
        this.safeFloat(offer.unitairehc) * this.safeFloat(d.CAHC) +
        this.safeFloat(offer.unitaire) * this.safeFloat(d.CABASE)
      );
    },
    
    // Calculate total budget including tax
    calculateTotalBudgetInclTax(offer, compteurData) {
      const ceeValue = typeof offer.cee === 'string' ? 0 : this.safeFloat(offer.cee);
      const consommationEnergie = this.calculateEnergieBudget(offer, compteurData);
      const consomationGlobale = this.safeFloat(offer.consomationGlobale);
      
      const supplies =
        consommationEnergie +
        this.safeFloat(offer.aboAns) +
        this.safeFloat(offer.green_energy_price) * consomationGlobale;
      
      const delivery = offer.TURPE === 'inclus'
        ? 0
        : this.safeFloat(compteurData.dataTurpe?.turpeValue);
      
      const cspe = this.safeFloat(offer.CSPE) * consomationGlobale;
      
      const taxesAndContributions =
        (ceeValue * consomationGlobale) +
        cspe +
        this.safeFloat(offer.budgetCapa) +
        this.safeFloat(offer.CTA);
      
      let tva = 0;
      const isC5 = (compteurData.typeCompteur || "").includes("C5");
      if (isC5) {
        const tva5 = (
          this.safeFloat(offer.aboAns) +
          this.safeFloat(compteurData.dataTurpe?.aboTurpe) +
          this.safeFloat(compteurData.dataTurpe?.CTA)
        ) * 0.20;
        
        const tva20 = (
          consommationEnergie + // Using the calculated energy consumption
          this.safeFloat(compteurData.dataTurpe?.energieTurp) +
          this.safeFloat(compteurData.dataTurpe?.cspeFinal) +
          (this.safeFloat(offer.green_energy_price) * consomationGlobale)
        ) * 0.20;
        
        tva = tva5 + tva20;
      } else {
        tva = this.safeFloat(offer.budget) * 0.2;
      }
      
      const totalBudgetExclTax = this.safeFloat(offer.budget);
      const totalBudgetInclTax = totalBudgetExclTax + tva;
      
      return totalBudgetInclTax;
    },
    
    // Calculate savings percentage including tax
    calculateSavingsPercentageInclTax(offer, currentOffer, compteurData) {
      try {
        const inclTaxOffer = this.calculateTotalBudgetInclTax(offer, compteurData);
        const inclTaxCurrent = this.calculateTotalBudgetInclTax(currentOffer, compteurData);
        
        if (inclTaxCurrent === 0) return 0;
        
        // Positive value means savings (current price - offer price)
        const savingsAmount = inclTaxOffer - inclTaxCurrent;
        const savingsPercentage = (savingsAmount / inclTaxCurrent) * 100;
        
        return savingsPercentage;
      } catch (err) {
        console.error("Error calculating savings:", err);
        return 0;
      }
    },
    calulatePercentage(compteurOffers, offer) {
      let actuelle = compteurOffers.find(o => o.typeFournisseur == 'Actuelle');
      let percentage = 0;
      let currentTotal = actuelle?.TotaleanuelleTTC || 0;
      let offerTotal = offer?.TotaleanuelleTTC || 0;
      
      if (currentTotal != 0) {
        percentage = this.calculateSavingsPercentageInclTax(offer, actuelle, currentTotal);
      }
      
      return percentage;
    },
    getPercentageColorClass(compteurOffers, offer) {
      const percentage = this.calulatePercentage(compteurOffers, offer);
      
      // Handle the formatted string case - extract the number
      let num = percentage;
      if (typeof percentage === 'string') {
        // Remove formatting and parse
        const cleaned = percentage.replace(/[^\d.-]/g, '');
        num = parseFloat(cleaned);
      }
      
      // Only return grey for truly invalid numbers
      if (typeof num !== 'number' || isNaN(num) || !isFinite(num)) {
        return 'grey--text';
      }
      
      // Simple rule: negative = green, zero or positive = red
      return num < 0 ? 'green--text' : 'red--text';
    },
    formatPercentage(percentage) {
      return new Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(percentage);
    },
    getTypeRemuneration(offer) {
      if (offer.ajouterMarge=='oui') {
        return 'Marge';
      } else if (offer.ajouterMarge=='non') {
        return 'Grille';
      }
      return '';
    },
    handleSwitchChange(val){
      console.log(val)
        this.expandedPanels = [0]; // Expand only the first panel on list change
      },
    handleFilters(filters) {
  this.activeFilters = filters;
  
  // Clone original propositions to avoid modifying the source
  let filtered = JSON.parse(JSON.stringify(this.Propositions));
  
  // Apply filters to each PDL's results
  filtered = filtered.map(pdl => {
    const pdlCopy = { ...pdl };
    
    // Filter the result array for each PDL
    if (pdlCopy.resultat && pdlCopy.resultat.result) {
      // Apply the active filters first
      pdlCopy.resultat.result = this.filterResultsByActiveFilters(pdlCopy.resultat.result);
      
      // Apply sorting if selected - only apply one sort at a time with budget taking precedence
      if (this.activeFilters.budgetSort) {
        pdlCopy.resultat.result = this.sortResultsByBudget(pdlCopy.resultat.result, this.activeFilters.budgetSort);
      } else if (this.activeFilters.commissionSort) {
        pdlCopy.resultat.result = this.sortResultsByCommission(pdlCopy.resultat.result, this.activeFilters.commissionSort);
      }
    }
    
    return pdlCopy;
  });
  
  // Update filtered propositions
  this.filteredPropositions = filtered;
},
sortResultsByBudget(results, sortDirection) {
  if (!results || !Array.isArray(results)) {
    return results;
  }
  
  // Filter out items without budget or error messages
  const sortableResults = results.filter(item => 
    item.budget && typeof item.budget === 'number' && 
    item.status !== 'error' && item.status !== 'enattend'
  );
  
  // Keep error messages separate
  const errorMessages = results.filter(item => 
    !item.budget || typeof item.budget !== 'number' || 
    item.status === 'error' || item.status === 'enattend'
  );
  
  // Sort the results with budget
  sortableResults.sort((a, b) => {
    if (sortDirection === 'asc') {
      return a.budget - b.budget;
    } else {
      return b.budget - a.budget;
    }
  });
  
  // Return sorted items with error messages at the end
  return [...sortableResults, ...errorMessages];
},

// Sort results by commission
sortResultsByCommission(results, sortDirection) {
  if (!results || !Array.isArray(results)) {
    return results;
  }
  
  // Filter out items without commission or error messages
  const sortableResults = results.filter(item => 
    item.commission !== undefined && 
    item.status !== 'error' && item.status !== 'enattend'
  );
  
  // Keep error messages separate
  const errorMessages = results.filter(item => 
    item.commission === undefined || 
    item.status === 'error' || item.status === 'enattend'
  );
  
  // Sort the results with commission
  sortableResults.sort((a, b) => {
    if (sortDirection === 'asc') {
      return a.commission - b.commission;
    } else {
      return b.commission - a.commission;
    }
  });
  
  // Return sorted items with error messages at the end
  return [...sortableResults, ...errorMessages];
},

// Filter results based on active filters
filterResultsByActiveFilters(results) {
  if (!this.activeFilters || !results || !Array.isArray(results)) {
    return results;
  }
  
  return results.filter(offer => {
    // Handle error messages specially
    if (offer.status === "error" || offer.status === "enattend") {
      return true; // Keep error messages intact
    }

    // Always show "Actuelle" offers for comparison
    if (offer.typeFournisseur === 'Actuelle') {
      return true;
    }


    // Check if we have a valid offer to filter
    if (!offer || !offer.fournisseur) {
      return false;
    }
    
    // Filter by suppliers
    if (this.activeFilters.suppliers && this.activeFilters.suppliers.length > 0) {
      if (!offer.fournisseur || !this.activeFilters.suppliers.includes(offer.fournisseur)) {
        return false;
      }
    }
    
 

    // Filter by durations
    if (this.activeFilters.durations && this.activeFilters.durations.length > 0) {
      if (!offer.DUREE || !this.activeFilters.durations.includes(parseInt(offer.DUREE))) {
        return false;
      }
    }
    
    // Filter by energy types
    if (this.activeFilters.types && this.activeFilters.types.length > 0) {
      // Get the type from the top-level property
      const offerType = offer.type;
      
      if (!offerType || !this.activeFilters.types.includes(offerType)) {
        return false;
      }
    }
    
    // Filter by commissions
    if (this.activeFilters.commissions && this.activeFilters.commissions.length > 0) {
      if (offer.commission === undefined || !this.activeFilters.commissions.includes(offer.commission)) {
        return false;
      }
    }
    
    if (this.activeFilters.remunerationTypes?.length > 0) {
      const currentRemuneration = offer.ajouterMarge === 'oui' ? 'Marge' : 'Grille';

      if (!this.activeFilters.remunerationTypes.includes(currentRemuneration)) {
        return false;
      }
  }
    
    
    // Filter by contract start date
    if (this.activeFilters.startDate) {
      const filterStartDate = new Date(this.activeFilters.startDate);
      // Convert from DD/MM/YYYY to Date object
      if (offer.dateDebut) {
        const [day, month, year] = offer.dateDebut.split('/');
        const offerStartDate = new Date(`${year}-${month}-${day}`);
        
        if (offerStartDate < filterStartDate) {
          return false;
        }
      }
    }
    
    // Filter by contract end date
    if (this.activeFilters.endDate) {
      const filterEndDate = new Date(this.activeFilters.endDate);
      // Convert from DD/MM/YYYY to Date object
      if (offer.dateFin) {
        const [day, month, year] = offer.dateFin.split('/');
        const offerEndDate = new Date(`${year}-${month}-${day}`);
        
        if (offerEndDate > filterEndDate) {
          return false;
        }
      }
    }
    
    // Filter by green energy
    if (this.activeFilters.greenEnergyOnly) {
      // Check if it's a green energy offer (prixVert > 0 or contains "VERT" in type)
      const isGreen = (offer.prixVert && offer.prixVert > 0) || 
                      (offer.type && offer.type.includes("VERT"));
      if (!isGreen) {
        return false;
      }
    }
    
    // If passed all filters, include the offer
    return true;
  });
},

// Sort results by budget
sortResults(results, sortDirection) {
  if (!results || !Array.isArray(results)) {
    return results;
  }
  
  // Filter out items without budget or error messages
  const sortableResults = results.filter(item => 
    item.budget && typeof item.budget === 'number' && 
    item.status !== 'error' && item.status !== 'enattend'
  );
  
  // Keep error messages separate
  const errorMessages = results.filter(item => 
    !item.budget || typeof item.budget !== 'number' || 
    item.status === 'error' || item.status === 'enattend'
  );
  
  // Sort the results with budget
  sortableResults.sort((a, b) => {
    if (sortDirection === 'asc') {
      return a.budget - b.budget;
    } else {
      return b.budget - a.budget;
    }
  });
  
  // Return sorted items with error messages at the end
  return [...sortableResults, ...errorMessages];
},
    
   
    async validerOffreMultiPrimeo(offre, transactionId, demandeur, firstName, lastName, phone, email, 
      donner, optionTarifaire, codePremio, numCompteur, societe, donnerEnedis, idHsto, PDL) {
        console.log(idHsto)
      var errorValide = 0;
      var msg = "";
      this.dialog = true;
      this.loading = true;
      this.error = false;
      this.messageDialogeError = "";
      this.messageDialogeSucces = "";
      var formData = new FormData();
      formData.append("offerId", offre);
      formData.append("transactionId", transactionId);
      formData.append("demandeur", demandeur);
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("phone", phone);
      formData.append("email", email);
      formData.append("numCompteur", numCompteur);
      formData.append("raison", societe.Raison);
      formData.append("idHsto", idHsto);
      // cout capa
      //upload pdf file to php server
      await axios({
        url: process.env.VUE_APP_URL_API_CLIENT + "ValiderOffrePrimeoMulti/",
        method: "POST",
        data: formData,
      })
      .then((res) => {
        if (res.data.valider == true) {
          this.listecodePremio = res.data.oppid;
          errorValide = 0;
        } else {
          errorValide = 1;
          msg = res.data.message;
        }
      })
      .catch((err) => {
        errorValide = 2;
      });
      if (errorValide == 0) {
        // await this.generatePdfNode(donner, donnerEnedis, optionTarifaire, numCompteur, societe, codePremio);
        this.loading = false;
        this.error = false;
        this.readonlyExpansionPanels = false;
        this.messageDialogeError = "l'offre a été validée avec succès";
        PDL.resultat.result.forEach((item)=>{
          if(item.hasOwnProperty('transactionId')){
            item.valider = 1
          }
        })
      } else if (errorValide == 1) {
        this.loading = false;
        this.readonlyExpansionPanels = false;
        this.error = true;
        this.messageDialogeError = msg;
        
        PDL.resultat.result.forEach((item)=>{
          if(item.hasOwnProperty('transactionId')){
            item.valider = 2
            item.messageValidation = msg
          }
        })
      } else if (errorValide == 2) {
        this.loading = false;
        this.readonlyExpansionPanels = false;
        this.error = true;
        
        PDL.resultat.result.forEach((item)=>{
          if(item.hasOwnProperty('transactionId')){
            item.valider = 2
            item.messageValidation = "une erreur s'est produite lors du validation d'offre";
          }
        })
        this.messageDialogeError = "une erreur s'est produite lors du validation d'offre";
      }
    },
    isSelectionOffreDisabled(index, indexPDL) {

    // Check if "Actuelle" exists for this specific PDL
    const hasActuelle = this.Propositions[indexPDL]?.resultat.result.some(
        result => result.typeFournisseur === "Actuelle"
    );

    const maxAllowed = hasActuelle ? 4 : 3;
    const isNotSelected = this.selectedData[indexPDL].indexOf(index) === -1;
    return isNotSelected && this.selectedData[indexPDL].length >= maxAllowed;
   },
    validOffre(offerId, transactionId, demandeur, firstName, lastName, phone, email) {
      this.dialog = true;
      this.loading = true;
      this.error = false;
      this.messageDialogeError = "";
      this.messageDialogeSucces = "";
      var formData = new FormData();
      formData.append("offerId", offerId);
      formData.append("transactionId", transactionId);
      formData.append("demandeur", demandeur);
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("phone", phone);
      formData.append("email", email);
      formData.append("numCompteur", this.numCompteur);
      formData.append("raison", this.SocieteData.Raison);
      // cout capa
      //upload pdf file to php server
      axios({
        url: process.env.VUE_APP_URL_API_CLIENT + "ValiderOffrePrimeo/",
        method: "POST",
        data: formData,
      })
        .then((res) => {
          if (res.data.valider == true) {
            this.codePremio = res.data.oppid;
            this.loading = false;
            this.error = false;
            this.messageDialogeSucces = "l'offre a été validée avec succès";
          } else {
            this.loading = false;
            this.error = true;
            this.messageDialogeError = res.data.message;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.error = true;
          this.messageDialogeError =
            "une erreur s'est produite lors du validation d'offre";
        });
    },
    filteredData(dataArray) {
      const filtered = [];
      const seen = new Set();
      dataArray.forEach(item => {
        // Check if logo is the same and status is 'enattend'
        if (item.hasOwnProperty('message') && item.hasOwnProperty('status') && (item.status == 'error' || item.status == 'enattend') && !seen.has(item.logo)) {
          filtered.push(item);
          seen.add(item.logo);
        }
      });
      return filtered;
    },
    getImageLogo(logo) {
      return require("@/assets/logoParticulier/" + logo);
    },
  },
};
</script>
<style scoped>
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel::after {
  border: none;
}
::v-deep .v-expansion-panel-content__wrap {
  padding: 0px !important;
}
::v-deep .v-expansion-panel-header__icon .v-icon.v-icon{
  margin-right: -10px !important;
  font-size: 40px !important;
}

@media only screen and (max-width: 600px) {
  .marginBtnPresentation {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
}

@media only screen and (max-width: 350px) {
  ::v-deep .v-expansion-panel-header {
    padding: 15px !important;
  }

  ::v-deep .responsiveSpan {
    font-size: 0.8rem !important;
  }
}
.validation-btn {
  background-color: #4CAF50 !important;
  color: white !important;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.5px;
  padding: 0 24px !important;
  height: 40px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 3px 5px rgba(0,0,0,0.1) !important;
}

.validation-btn:hover {
  background-color: #43A047 !important;
  transform: translateY(-2px);
  box-shadow: 0 5px 8px rgba(0,0,0,0.2) !important;
}

.validation-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
}

.validation-btn .v-icon {
  margin-right: 8px;
  font-size: 20px;
}
</style>
